module.exports = __webpack_public_path__ + "media/images/triangle--down--rb-dark-blue-19da681c3b6d6b79674f1820efea9b0c.png";